import { filterConfig } from "@modules/global/filter-config.ts"
import { fetchJson } from "@modules/util/fetch-json.ts"
import { debounce } from "lodash-es"
import { getLocationAsString } from "../location/location"
import type { ApiFiltersResult } from "../types"
import { getQueryParametersAsString } from "../util/query-parameter"
import { getCategoriesAsString } from "./category"
import { getFiltersAsString } from "./filter"

let filterApiResult: ApiFiltersResult | undefined

export function getFilterApiResult() {
    return filterApiResult
}

export function createPathWithAllFilters(SiteInfoController = "") {
    // figur:skinny,mollig;typ:afrikanisch,deutsch,latina,arabisch;intimbereich:rasiert
    // /[ORT,REGION,PLZ-ORT?]/sex-anzeigen/[RUBRIK?]/[FILTER?][QUERY?]
    const location = getLocationAsString()
    const filterString = getFiltersAsString()
    const categoryString = getCategoriesAsString()
    const queryParamsString = getQueryParametersAsString()
    const path = [location, "sex-anzeigen", categoryString, filterString].filter((value) => value.trim().length !== 0)

    if (SiteInfoController === "index" && location === "muenchen") {
        const Exceptionalpath = [location, "", categoryString, filterString].filter(
            (value) => value.trim().length !== 0,
        )
        return `/${Exceptionalpath.join("/")}${queryParamsString}`
    }

    return `/${path.join("/")}${queryParamsString}`
}

export async function fetchApiWithAllFilters() {
    const [res, err] = await fetchJson(`/api${createPathWithAllFilters()}`)
    if (err && res.error === "CoordinatesNotInSessionException") {
        window.location.href = "/#geoRetry"
        return
    }
    filterApiResult = res
    return filterApiResult
}

export async function fetchApiWithAllFiltersAddDistance() {
    const [res, err] = await fetchJson(`/api/add-distance${createPathWithAllFilters()}`)
    if (err && res.error === "CoordinatesNotInSessionException") {
        window.location.href = "/#geoRetry"
        return
    }
    filterApiResult = res
    return filterApiResult
}

export const fetchApiWithAllFiltersDebounced = debounce(async (callback: (result: ApiFiltersResult) => void) => {
    const result = await fetchApiWithAllFilters()
    if (callback && result) {
        callback(result)
    }
}, filterConfig.apiFetchDebounceMs)
